import React, { useContext, useEffect, useRef } from "react";
import styles from "./Message.module.scss";
import PathContext from "../../context/path";
const Message = (props) => {
  const { img, name, position, text, color, float, emoji } = props;
  const path = useContext(PathContext);

  const refWrap = useRef(null);
  const refTrigger = useRef(null);
  let wrapClass = `${styles.wrap}`;
  let emojiContainer = null;
  useEffect(()=>{
    const wrap = refWrap.current;
    const trigger = refTrigger.current;
    const animateObserver = (element) => {
      let options = {
        threshold: 1,
        rootMargin: '0% 50% -10% 50%'
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            wrap.classList.add(styles.animate);
            observer.unobserve(trigger);
          // } else {
          //   element.classList.remove('fixed');
          }
        })
      }, options);
      observer.observe(element);
    }
    animateObserver(trigger);
  },[]);
  if (float !== undefined && styles[`wrap_${float}`] !== undefined) {
    wrapClass += ` ${styles[`wrap_${float}`]}`;
  }
  if (color !== undefined && styles[`wrap_${color}`] !== undefined) {
    wrapClass += ` ${styles[`wrap_${color}`]}`;
  }
  if (emoji !== undefined && emoji.length > 0) {
    let array = [];
    emoji.forEach((element, index) => {
      let item = <div className={styles.emoji} key={`emoji-${index}`} >
        
        <img src={`${path}/img/emoji-${element}@2x.webp`} alt="" />
      </div>
      array.push(item);
    });
    emojiContainer = <div className={styles.emojies}>{array}</div>
  }
  let nameElement = null;
  if(name !== undefined && name !== ''){
    nameElement = <span>{name}, </span>;
  }
  return (
    <>
      <div className={styles.trigger} ref={refTrigger}>
      <div className={wrapClass} ref={refWrap}>
        <div className={styles.header}>
          <div className={styles.img}>
            <img src={`${path}/img/${img}.webp`} alt="" />
          </div>
          {nameElement}
          {position}
        </div>
        <div className={styles.body}>{text}</div>
        {emojiContainer}
      </div>
      </div>
    </>
  );

}

export default Message;
